<template>
  <div id="adminSitemap">
    <vue-headful title="Admin" lang="en" />
    <a  class="nav-link" :href="origin + '/sitemap.xml'" target="blank">Check Sitemap</a>
    <div v-if="sitemapContentExists" class="mt-3">
      <b-container class="bv-example-row mt-3"
          v-for="( urlName, index) in sitemapContent.urlset.url"
          :key="index"
        >
          <b-row
          class="mt-2"
          v-for="( value, name, i) in urlName"
          :key="i"
          >
            <b-col>{{ name }}</b-col>
            <b-col>{{ value[0] }}</b-col>
            <b-col>
              <input v-model="value[0]" v-show="name=='priority'" placeholder="value between 0.0 - 1.0" />
            </b-col>
          </b-row>
          <hr>
      </b-container>
    </div>
    <button type="button" @click="submitDocument" class="btn btn-primary float-right">SAVE</button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import myMixin from '../mixnin'

export default {
  name: 'adminExtras',
  data () {
    return {
      linguas: [],
      traducoes: {},
      sel: '',
      sitemapContent: {},
      sitemapContentExists: false,
      origin: window.location.origin
    }
  },
  mixins: [myMixin],
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Sitemap')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.linguas = JSON.parse(this.$store.state.option.langs)
        this.traducoes = this.$store.state.option
        this.sel = this.linguas[0]
        // get sitemap.xml and parse it to json
        this.getSitemapJson(this)
      } else {
        this._.delay(this.init, 100)
      }
    },
    submitDocument () {
      this.submitSitemapChanges(this.parseJsonToXml(this.sitemapContent))
    }
  }
}
</script>
